<template>
  <main class="w-full flex-grow p-6">
    <BackButton />
    <div class="flex justify-between items-center">
      <div class="">
        <h1 class="text-3xl font-bold text-app-default">Event/Detail</h1>
      </div>
      <div class="flex">
        <div @click="showModalDestroy" class="mr-5 cursor-pointer">
          <fas icon="trash-alt" class="text-red-600 text-2xl" />
        </div>
      </div>
    </div>

    <!-- <div class="w-full lg:w-full my-6 pr-0 lg:pr-2">
      <div class="leading-loose">
        <div class="p-5 bg-white rounded shadow-xl">
          <div class="flex justify-between border-b-2 mb-5 pb-5">
            <div class="font-bold text-2xl">
              Carousel Image/Video mp4 (1200 px X 500 px)
            </div>
            <div @click="showModalCarouselFile" class="mr-5 cursor-pointer">
              <fas icon="pencil-alt" class="text-app-default text-2xl" />
            </div>
          </div>
          <div class="flex">
            <div class="" v-if="isVideo">
              <iframe :src="dataEvent.event_carousel" />
            </div>
            <img
              v-else
              class="w-full lg:w-9/12 mr-3 h-44 lg:h-80"
              :src="dataEvent.event_carousel"
              alt="23paskal"
            />
          </div>
        </div>
      </div>
    </div> -->

    <div class="w-full lg:w-full my-6 pr-0 lg:pr-2">
      <div class="leading-loose">
        <div class="p-5 bg-white rounded shadow-xl">
          <div class="flex justify-between border-b-2 mb-5 pb-5">
            <div class="font-bold text-2xl">Products (1020 px X 1020 px)</div>
            <div @click="showModalProductFile" class="mr-5 cursor-pointer">
              <fas icon="pencil-alt" class="text-app-default text-2xl" />
            </div>
          </div>
          <div class="flex">
            <img
              
              :key="dataEvent.event_images"
              class="w-56 h-56 mr-3"
              :src="dataEvent.event_images"
              alt="23paskal"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="w-full lg:w-full my-6 pr-0 lg:pr-2">
      <div class="leading-loose">
        <div class="p-5 bg-white rounded shadow-xl">
          <div class="flex justify-between border-b-2 mb-5 pb-5">
            <div class="font-bold text-2xl">Event Info</div>
            <div @click="showModalEditPromoInfo" class="mr-5 cursor-pointer">
              <fas icon="pencil-alt" class="text-app-default text-2xl" />
            </div>
          </div>
          <div class="font-semibold">URL Video</div>
          <div v-if="dataEvent.event_carousel !== ''" class="ml-5">
            {{ dataEvent.event_carousel }}
          </div>
          <div v-else class="ml-5">-</div>
          <div class="font-semibold">Name</div>
          <div v-if="dataEvent.event_name !== ''" class="ml-5">
            {{ dataEvent.event_name }}
          </div>
          <div v-else class="ml-5">-</div>
          <div class="font-semibold">First Title</div>
          <div v-if="dataEvent.event_first_title !== ''" class="ml-5">
            {{ dataEvent.event_first_title }}
          </div>
          <div class="font-semibold">First Description</div>
          <!-- <div v-if="dataEvent.event_first_description !== ''" class="ml-5">
            {{ dataEvent.event_first_description }}
          </div> -->
          <div class="ml-5" v-html="dataEvent.event_first_description"></div>
          <div class="font-semibold">Second Title</div>
          <div v-if="dataEvent.event_second_title !== ''" class="ml-5">
            {{ dataEvent.event_second_title }}
          </div>
          <div class="font-semibold">Second Description</div>
          <!-- <div v-if="dataEvent.event_second_description !== ''" class="ml-5">
            {{ dataEvent.event_second_description }}
          </div> -->
          <div class="ml-5" v-html="dataEvent.event_second_description"></div>
          <div class="font-semibold">Status</div>
          <div v-if="dataEvent.is_active" class="ml-5">Active</div>
          <div v-else class="ml-5">Non Active</div>
          <div class="font-semibold">Event Start</div>
          <div v-if="dataEvent.event_start !== null" class="ml-5">
            {{ event_start }}
          </div>
          <div v-else class="ml-5">-</div>
          <div class="font-semibold">Event End</div>
          <div v-if="dataEvent.event_end !== null" class="ml-5">
            {{ event_end }}
          </div>
          <div v-else class="ml-5">-</div>
        </div>
      </div>
    </div>

    <!-- Modal destroy -->
    <div
      v-if="modalDestroy"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed flex items-center"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 400px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <button
            @click.self="showModalDestroy"
            class="fill-current h-6 w-6 absolute right-0 top-0 m-6 font-3xl font-bold"
          >
            &times;
          </button>
          <div class="px-6 py-3 text-xl border-b font-bold">Warning !</div>
          <div class="p-6 flex-grow">
            Continue To Delete This Event
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="showModalDestroy"
                type="button"
                class="bg-green-400 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                @click="deleteEvent"
                type="button"
                class="bg-red-500 text-gray-200 rounded px-4 py-2 w-32"
              >
                {{ deleteButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="showModalDestroy"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>

    <!-- Modal Update -->
    <div
      v-if="modalInfoPromo"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 800px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <button
            @click.self="showModalEditPromoInfo"
            class="fill-current h-6 w-6 absolute right-0 top-0 m-6 font-3xl font-bold"
          >
            &times;
          </button>
          <div class="px-6 py-3 text-xl border-b font-bold">Edit Info</div>
          <div class="p-6 flex-grow">
            <div class="flex flex-wrap">
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Status</label
                >
                <div class="flex flex-row items-center h-9 mb-5">
                  <div
                    class="relative cursor-pointer"
                    @click="update.is_active = !update.is_active"
                  >
                    <div
                      class="w-10 h-4 bg-gray-400 rounded-full shadow-inner items-center p-1 duration-300 ease-in-out"
                      :class="{ 'bg-app-default': update.is_active }"
                    ></div>
                    <div
                      class="absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-1 transition transform duration-300 ease-in-out"
                      :class="{ 'translate-x-6': update.is_active }"
                    ></div>
                  </div>
                </div>
              </div>
              <div class="w-full lg:w-1/2 pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >URL Video</label
                >
                <input
                  v-model="update.event_carousel"
                  @keyup="eventCarouselChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.event_carousel
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="ex: https://www.youtube.com/watch?v=Jp8Qijz5als"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.event_carousel_msg }}
                </div>
              </div>
              <div class="w-full lg:w-1/2 pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80">Name</label>
                <input
                  v-model="update.event_name"
                  @keyup="eventNameChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.event_name
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Name"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.event_name_msg }}
                </div>
              </div>
              <div class="w-full lg:w-1/2 pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >First Title</label
                >
                <input
                  v-model="update.event_first_title"
                  @keyup="eventFirstTitleChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.event_first_title
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Name"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.event_first_title_msg }}
                </div>
              </div>
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >First Description</label
                >
                <!-- <textarea
                  v-model="update.event_first_description"
                  @keyup="eventFirstDescriptionChange"
                  rows="5"
                  class="w-full pl-3 pr-3 py-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.event_first_description
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Description"
                >
                </textarea> -->
                <div
                  class="w-full pl-3 pr-3 py-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.event_first_description
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                >
                  <CKEditor
                    v-model="update.event_first_description"
                    :disabled="false"
                    :toolbar="toolbar"
                    @onChange="eventFirstDescriptionChange"
                  />
                </div>
                <div
                  class="text-right text-sm "
                  :class="[
                    update?.event_first_description?.length <= 2000
                      ? 'text-gray-600'
                      : 'text-red-600',
                  ]"
                >
                  {{ update?.event_first_description?.length }} used out of 2000
                  characters
                </div>
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.event_first_description_msg }}
                </div>
              </div>
              <div class="w-full lg:w-1/2 pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Second Title</label
                >
                <input
                  v-model="update.event_second_title"
                  @keyup="eventSecondTitleChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.event_second_title
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Name"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.event_second_title_msg }}
                </div>
              </div>
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Second Description</label
                >
                <!-- <textarea
                  v-model="update.event_second_description"
                  @keyup="eventSecondDescriptionChange"
                  rows="5"
                  class="w-full pl-3 pr-3 py-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.event_second_description
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Description"
                >
                </textarea> -->
                <div
                  class="w-full pl-3 pr-3 py-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.event_second_description
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                >
                  <CKEditor
                    v-model="update.event_second_description"
                    :disabled="false"
                    :toolbar="toolbar"
                    @onChange="eventSecondDescriptionChange"
                  />
                </div>
                <div
                  class="text-right text-sm "
                  :class="[
                    update?.event_second_description?.length <= 2000
                      ? 'text-gray-600'
                      : 'text-red-600',
                  ]"
                >
                  {{ update?.event_second_description?.length }} used out of
                  2000 characters
                </div>
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.event_second_description_msg }}
                </div>
              </div>
              <div class="w-full lg:w-1/2 pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Star Event</label
                >
                <v-date-picker
                  timezone="Asia/Jakarta"
                  v-model="update.event_start"
                  mode="dateTime"
                  is24hr
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <input
                      class="px-2 py-1 border-2 border-gray-200 rounded focus:outline-none focus:border-blue-300 w-full"
                      :value="inputValue"
                      v-on="inputEvents"
                    />
                  </template>
                </v-date-picker>
              </div>
              <div class="w-full lg:w-1/2 pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >End Event</label
                >
                <v-date-picker
                  timezone="Asia/Jakarta"
                  v-model="update.event_end"
                  mode="dateTime"
                  is24hr
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <input
                      class="px-2 py-1 border-2 border-gray-200 rounded focus:outline-none focus:border-blue-300 w-full"
                      :value="inputValue"
                      v-on="inputEvents"
                    />
                  </template>
                </v-date-picker>
              </div>
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="showModalEditPromoInfo"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                @click="updatePromoInfo"
                type="button"
                class="bg-blue-600 text-gray-200 rounded px-4 py-2 w-32"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="showModalEditPromoInfo"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>

    <!-- Modal Carousel -->
    <div
      v-if="modalCarousel"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed flex items-center"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 800px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <div class="flex flex-row border-b items-center justify-between">
            <div class="px-6 py-3 text-xl font-bold">
              Update Carousel Image/Video
            </div>
            <div class="">
              <button
                @click.self="showModalCarouselFile"
                class="font-3xl font-bold p-6"
              >
                &times;
              </button>
            </div>
          </div>
          <div class="p-6 flex-grow">
            <div class="">
              <div
                class="border-dotted border-2 p-2 rounded-lg"
                :class="[
                  errors.event_carousel ? 'border-red-400' : 'border-black',
                ]"
                @drop="previewFileCarousel"
              >
                <input
                  type="file"
                  accept="image/*, video/*"
                  @change="previewFileCarousel"
                  id="carousel_file"
                  class="opacity-0 hidden"
                />
                <div class="flex flex-row">
                  <div
                    v-if="avatar.previewCarousel"
                    class="mr-1 relative rounded-lg w-full"
                  >
                    <button
                      class="absolute right-2 top-2"
                      type="button"
                      @click="removeCarouselFile()"
                    >
                      <fas icon="trash-alt" class="text-red-600 text-3xl" />
                    </button>
                    <iframe
                      v-if="isVideoEdit"
                      :src="avatar.previewCarousel"
                      class="w-full h-80 rounded-lg"
                    />
                    <img
                      v-else
                      :src="avatar.previewCarousel"
                      class="w-full h-80 rounded-lg"
                    />
                  </div>
                  <div
                    v-if="avatar.previewCarousel === null"
                    v-cloak
                    @click="chooseCarouselFile()"
                    class="w-full h-80 mr-1 rounded-lg cursor-pointer bg-gray-200 flex items-center justify-center"
                  >
                    <fas icon="image" class="text-gray-600 text-3xl" />
                  </div>
                </div>
              </div>
              <div class="text-sm text-red-600 mb-5">
                {{ errors.event_carousel_msg }}
              </div>
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="showModalCarouselFile"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                @click="updateCarousel"
                type="button"
                class="bg-blue-600 text-gray-200 rounded px-4 py-2 w-32"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="showModalCarouselFile"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>

    <!-- Modal product -->
    <div
      v-if="productModal"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed flex items-center"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 450px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <div class="flex flex-row border-b items-center justify-between">
            <div class="px-6 py-3 text-xl font-bold">
              Products (1020 px X 1020 px)
            </div>
            <div class="">
              <button
                @click.self="showModalProductFile"
                class="font-3xl font-bold p-6"
              >
                &times;
              </button>
            </div>
          </div>
          <div class="p-6 flex-grow">
            <div
              class="border-dotted border-2 p-2 rounded-lg"
              :class="[errors.event_images ? 'border-red-400' : 'border-black']"
              @drop="previewFileProduct"
            >
              <input
                type="file"
                accept="image/*"
                @change="previewFileProduct"
                id="product_file"
                class="opacity-0 hidden"
              />
              <div class="flex flex-row flex-wrap">
                <div
                  v-if="avatar.previewProducts.length"
                  class="mr-1 relative rounded-lg"
                >
                  <button
                    class="absolute right-2 top-2"
                    type="button"
                    @click="removeProductFile"
                  >
                    <fas icon="trash-alt" class="text-red-600 text-3xl" />
                  </button>
                  <img
                    :src="avatar.previewProducts[0]"
                    class="w-96 h-80 rounded-lg"
                  />
                </div>
                <div
                  v-if="avatar.previewProducts.length === 0"
                  v-cloak
                  @click="chooseFileProduct()"
                  class="w-96 h-80 mr-1 rounded-lg cursor-pointer bg-gray-200 flex items-center justify-center"
                >
                  <fas icon="image" class="text-gray-600 text-3xl" />
                </div>
              </div>
            </div>
            <div class="text-sm text-red-600 mb-5">
              {{ errors.event_images_msg }}
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="showModalProductFile"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                :disabled="avatar.previewProducts.length === 0"
                @click="updateImageProductEvent"
                type="button"
                class="text-gray-200 rounded px-4 py-2 w-32"
                :class="[
                  avatar.previewProducts.length === 0
                    ? 'bg-gray-500'
                    : 'bg-blue-600',
                ]"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="showModalProductFile"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>

    <Warning />
    <SuccessNotif />
  </main>
</template>

<script>
import API from "../../api";
import CKEditor from "../../components/CKEditor.vue";
import BackButton from "../../components/BackButton.vue";
import Warning from "../../components/Warning.vue";
import SuccessNotif from "../../components/SuccessNotif.vue";
export default {
  name: "ContentDetail",
  components: {
    Warning,
    BackButton,
    SuccessNotif,
    CKEditor,
  },
  // delimiters: ['${', '}'], // Avoid Twig conflicts
  data() {
    return {
      toolbar: {
        items: [
          "bold",
          "italic",
          "underline",
          "|",
          "superscript",
          "subscript",
          "strikethrough",
          "|",
          "outdent",
          "indent",
          "alignment",
          "|",
          "undo",
          "redo",
        ],
      },
      dataEvent: {},
      eventStart: new Date(),
      eventEnd: new Date(),
      promoCategoryList: [],
      modalDestroy: false,
      modalInfoPromo: false,
      modalCarousel: false,
      productModal: false,
      isVideo: true,
      isVideoEdit: false,
      event_start: "",
      event_end: "",
      errors: {
        event_images: false,
        event_carousel: false,
        event_images_msg: "",
        event_carousel_msg: "",
        event_name: false,
        event_name_msg: "",
        event_first_title: false,
        event_first_title_msg: "",
        event_first_description: false,
        event_first_description_msg: "",
        event_second_title: false,
        event_second_title_msg: "",
        event_second_description: false,
        event_second_description_msg: "",
        event_start: false,
        event_start_msg: "",
        event_end: false,
        event_end_msg: "",
        is_active: false,
        is_active_msg: "",
      },
      update: {
        event_name: "",
        event_carousel: "",
        event_first_title: "",
        event_first_description: "",
        event_second_title: "",
        event_second_description: "",
        event_start: new Date(),
        event_end: new Date(),
        is_active: true,
      },
      avatar: {
        previewCarousel: null,
        fileCarousel: null,
        previewProducts: [],
        fileProducts: [],
      },
      saveButton: "Save",
      deleteButton: "Delete",
    };
  },
  methods: {
    eventNameChange: function(e) {
      this.update.event_name = e.target.value;
      this.errors.event_name = false;
      this.errors.event_name_msg = "";
    },
    eventCarouselChange: function(e) {
      this.update.event_carousel = e.target.value;
      this.errors.event_carousel = false;
      this.errors.event_carousel_msg = "";
    },
    eventFirstTitleChange: function(e) {
      this.update.event_first_title = e.target.value;
      this.errors.event_first_title = false;
      this.errors.event_first_title_msg = "";
    },
    eventFirstDescriptionChange: function() {
      // this.update.event_first_description = e.target.value;
      this.errors.event_first_description = false;
      this.errors.event_first_description_msg = "";
    },
    eventSecondTitleChange: function(e) {
      this.update.event_second_title = e.target.value;
      this.errors.event_second_title = false;
      this.errors.event_second_title_msg = "";
    },
    eventSecondDescriptionChange: function() {
      // this.update.event_second_description = e.target.value;
      this.errors.event_second_description = false;
      this.errors.event_second_description_msg = "";
    },
    chooseFileProduct: function() {
      document.getElementById("product_file").click();
    },
    chooseCarouselFile: function() {
      document.getElementById("carousel_file").click();
    },
    removeProductFile() {
      this.avatar.previewProducts = [];
      this.avatar.fileProducts = [];
    },
    removeCarouselFile: function() {
      this.avatar.previewCarousel = null;
      this.avatar.fileCarousel = null;
    },
    previewFileProduct: function(event) {
      let input = event.target;
      let count = input.files.length;
      let index = 0;
      if (input.files) {
        while (count--) {
          let reader = new FileReader();
          reader.onload = (e) => {
            this.avatar.previewProducts.push(e.target.result);
          };
          this.avatar.fileProducts.push(input.files[index]);
          reader.readAsDataURL(input.files[index]);
          index++;
        }
      }
      this.errors.event_images = false;
      this.errors.event_images_msg = "";
    },
    previewFileCarousel: function(event) {
      let input = event.target;
      if (input.files) {
        if (this.isVideoExtension(input.files[0].name)) {
          this.isVideoEdit = true;
        } else {
          this.isVideoEdit = false;
        }
        let reader = new FileReader();
        reader.onload = (e) => {
          this.avatar.previewCarousel = e.target.result;
        };
        this.avatar.fileCarousel = input.files[0];
        reader.readAsDataURL(input.files[0]);
      }
      this.errors.event_carousel = false;
      this.errors.event_carousel_msg = "";
    },
    showModalDestroy: function() {
      this.modalDestroy = !this.modalDestroy;
    },
    showModalCarouselFile: function() {
      this.avatar = {
        previewCarousel: null,
        fileCarousel: null,
        previewProducts: [],
        fileProducts: [],
      };
      this.modalCarousel = !this.modalCarousel;
    },
    showModalProductFile: function() {
      this.avatar = {
        previewCarousel: null,
        fileCarousel: null,
        previewProducts: [],
        fileProducts: [],
      };
      this.productModal = !this.productModal;
    },
    showModalEditPromoInfo: function() {
      this.update.event_name = this.dataEvent.event_name;
      this.update.event_carousel = this.dataEvent.event_carousel;
      this.update.event_description = this.dataEvent.event_description;
      this.update.event_first_title = this.dataEvent.event_first_title;
      this.update.event_first_description = this.dataEvent.event_first_description;
      this.update.event_second_title = this.dataEvent.event_second_title;
      this.update.event_second_description = this.dataEvent.event_second_description;
      this.update.event_start = new Date(this.dataEvent.event_start);
      this.update.event_end = new Date(this.dataEvent.event_end);
      this.update.is_active = this.dataEvent.is_active;
      this.modalInfoPromo = !this.modalInfoPromo;
    },
    deleteEvent: async function() {
      this.deleteButton = "Loading...";
      try {
        let res = await fetch(`${API}v1/admin/cms/event/delete`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify({
            id: this.dataEvent.id,
          }),
        });
        let respon = await res.json();
        if (respon.status === 400) {
          this._error(respon.message);
          this.modalDestroy = false;
          this.deleteButton = "Delete";
          return;
        } else if (respon.status !== 200) {
          this._error("internal server error");
          this.modalDestroy = false;
          this.deleteButton = "Delete";
          return;
        }
        this.modalDestroy = false;
        this.deleteButton = "Delete";
        this.$router.push(`/event`);
        this._success("Data deleted.");
      } catch (err) {
        this.deleteButton = "Delete";
        this.modalDestroy = false;
        this._error("internal server error");
      }
    },
    updateCarousel: async function() {
      this.saveButton = "Loading...";
      let formdata = new FormData();
      formdata.append("event_carousel", this.avatar.fileCarousel);
      formdata.append("id", this.dataEvent.id);
      try {
        let res = await fetch(`${API}v1/event/carousel`, {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: formdata,
        });
        const response = await res.json();
        if (response.status !== 200) {
          if (response.message === "ERR_FORM") {
            response.data.map((item) => {
              if (item.key === "event_carousel") {
                this.errors.event_carousel = true;
                this.errors.event_carousel_msg = item.message;
              }
            });
            this.saveButton = "Save";
            return;
          }
          this.saveButton = "Save";
          return;
        }
        this.modalCarousel = false;
        this.saveButton = "Save";
        this.detailEvent();
        this._success("Data updated.");
      } catch (err) {
        this.saveButton = "Save";
        this.modalCarousel = false;
        this._error("internal server error");
      }
    },
    updateImageProductEvent: async function() {
      this.saveButton = "Loading...";
      let formdata = new FormData();
      formdata.append("id", this.dataEvent.id);
      this.avatar.fileProducts.map((itm) => {
        formdata.append("event_images", itm);
      });
      try {
        let res = await fetch(`${API}v1/admin/cms/event/update-image`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: formdata,
        });
        const response = await res.json();
        if (response.status !== 200) {
          if (response.message === "ERR_FORM") {
            response.data.map((item) => {
              if (item.key === "event_images") {
                this.errors.event_images = true;
                this.errors.event_images_msg = item.message;
              }
              // if (item.key === 'event_carousel'){
              //   this.errors.event_carousel = true
              //   this.errors.event_carousel_msg = item.message
              // }
            });
            this.saveButton = "Save";
            return;
          }
          this.productModal = false;
          this.saveButton = "Save";
          this._error(response.message);
          return;
        }
        this.productModal = false;
        this.saveButton = "Save";
        this.detailEvent();
        this._success("Data updated.");
      } catch (err) {
        this.productModal = false;
        this.saveButton = "Save";
        this._error("internal server error");
      }
    },
    convertTZ: function(date, tzString) {
      return new Date(
        (typeof date === "string"
          ? new Date(date)
          : date
        ).toLocaleString("en-US", { timeZone: tzString })
      );
    },
    updatePromoInfo: async function() {
      let data = {
        id: this.dataEvent.id,
        event_name: this.update.event_name,
        event_carousel: this.update.event_carousel,
        event_description: this.update.event_description,
        event_start: this.update.event_start,
        event_end: this.update.event_end,
        is_active: this.update.is_active,
        event_first_title: this.update.event_first_title,
        event_first_description: this.update.event_first_description,
        event_second_title: this.update.event_second_title,
        event_second_description: this.update.event_second_description,
      };
      this.saveButton = "Loading...";
      try {
        let res = await fetch(`${API}v1/admin/cms/event/update`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify(data),
        });
        const response = await res.json();
        if (response.status !== 200) {
          if (response.message === "ERR_FORM") {
            response.data.map((item) => {
              // if (item.key === 'event_images'){
              //   this.errors.event_images = true
              //   this.errors.event_images_msg = item.message
              // }
              if (item.key === "event_carousel") {
                this.errors.event_carousel = true;
                this.errors.event_carousel_msg = item.message;
              }
              if (item.key === "event_name") {
                this.errors.event_name = true;
                this.errors.event_name_msg = item.message;
              }
              if (item.key === "event_first_title") {
                this.errors.event_first_title = true;
                this.errors.event_first_title_msg = item.message;
              }
              if (item.key === "event_first_description") {
                this.errors.event_first_description = true;
                this.errors.event_first_description_msg = item.message;
              }
              if (item.key === "event_second_title") {
                this.errors.event_second_title = true;
                this.errors.event_second_title_msg = item.message;
              }
              if (item.key === "event_second_description") {
                this.errors.event_second_description = true;
                this.errors.event_second_description_msg = item.message;
              }
              if (item.key === "event_start") {
                this.errors.event_start = true;
                this.errors.event_start_msg = item.message;
              }
              if (item.key === "event_end") {
                this.errors.event_end = true;
                this.errors.event_end_msg = item.message;
              }
              if (item.key === "is_active") {
                this.errors.is_active = true;
                this.errors.is_active_msg = item.message;
              }
            });
            this.saveButton = "Save";
            return;
          }
          this.modalInfoPromo = false;
          this.saveButton = "Save";
          this._error(response.message);
          return;
        }
        this.modalInfoPromo = false;
        this.detailEvent();
        this.saveButton = "Save";
        this._success("Data updated.");
      } catch (err) {
        this.modalInfoPromo = false;
        this.saveButton = "Save";
        this._error("internal server error");
      }
    },
    detailEvent: async function() {
      try {
        let res = await fetch(`${API}v1/event/${this.$route.params.id}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("internal server error");
          return;
        }
        // this.cekExtension(respon.data.event_carousel);
        this.dataEvent = respon.data;
        let stE = new Date(respon.data.event_start);
        let enE = new Date(respon.data.event_end);
        this.event_start = `${stE.getDate()}-${stE.getMonth() +
          1}-${stE.getFullYear()} ${stE.getHours()}:${stE.getMinutes()}`;
        this.event_end = `${enE.getDate()}-${enE.getMonth() +
          1}-${enE.getFullYear()} ${enE.getHours()}:${enE.getMinutes()}`;
      } catch (err) {
        this._error("internal server error");
      }
    },
    cekExtension: function(nameFile) {
      const imageFormat = ["jpg", "png", "jpeg"];
      const videoFormat = ["mp4", "3gp"];
      let regexExtension = "[^.]+$";
      let extension = nameFile.match(regexExtension);
      if (imageFormat.includes(extension[0])) {
        this.isVideo = false;
      }
      if (videoFormat.includes(extension[0])) {
        this.isVideo = true;
      }
    },
    isVideoExtension: function(nameFile) {
      const imageFormat = ["jpg", "png", "jpeg", "gif"];
      const videoFormat = ["mp4", "3gp"];
      let regexExtension = "[^.]+$";
      let extension = nameFile.toLowerCase().match(regexExtension);
      if (imageFormat.includes(extension[0])) {
        return false;
      }
      if (videoFormat.includes(extension[0])) {
        return true;
      }
    },
    _error: function(message) {
      this.$store.dispatch("warning", {
        isError: true,
        message: message,
      });
      setTimeout(() => {
        this.$store.dispatch("warning", {
          isError: false,
          message: "",
        });
      }, 5000);
    },
    _success: function(message) {
      this.$store.dispatch("success", {
        isSuccess: true,
        message: message,
      });
      setTimeout(() => {
        this.$store.dispatch("success", {
          isSuccess: false,
          message: "",
        });
      }, 5000);
    },
  },
  created() {
    this.detailEvent();
  },
};
</script>
